import * as React from 'react';

import { ApplicationState } from '../../store';
import BelfiusCurrencyText from './belfius-currency-text';
import { GuaranteeResponse } from '../../store/details/policy/model';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';

interface GuaranteeInformationProps {
  readonly headerText: string;
  readonly headerColor?: string;
  readonly information: ReadonlyArray<GuaranteeResponse>;
  readonly translation?: string;
}

interface PropsFromState {
  readonly currentLanguage: string;
}

type AllProps = GuaranteeInformationProps & PropsFromState;

const styles = {
  informationContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginLeft: '10px'
  },
  guaranteeContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginBottom: '10px',
    borderBottom: '1px solid #8fabd9'
  },
  guaranteeHeader: {
    display: 'flex',
    flexDirection: 'column' as 'column'
  },
  guaranteeGuarantee: {
    fontStyle: 'italic' as 'italic'
  },
  guaranteeObject: {
    fontWeight: 'bolder' as 'bolder',
  },
  guaranteeInfo: {
    flex: '1 1',
    justifyContent: 'start',
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'row' as 'row'
  },
  keyContainer: {
    display: 'flex',
    flexBasis: '65%'
  },
  key: {
    justifyContent: 'start',
    alignItems: 'start',
    flexDirection: 'column' as 'column',
    fontSize: '13pt',
    fontWeight: 'bolder' as 'bolder'
  },
  valueContainer: {
    display: 'flex'
  },
  value: {
    fontSize: '13pt',
  }
};

class GuaranteeInformation extends React.PureComponent<AllProps> {

  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);

    this.localization = getI18n();
  }

  render() {
    const info = [...this.props.information]
      .sort((a, b) => {
        return a.objectSequence - b.objectSequence || a.guaranteeSequence - b.guaranteeSequence;
      })
      .map((guarantee, i) => {
        return (
          <div style={styles.guaranteeContainer} key={i}>
            <div style={styles.guaranteeInfo}>
              <div style={styles.keyContainer}><span style={styles.guaranteeObject}>{guarantee.object}</span></div>
              <div style={styles.valueContainer}><span style={styles.guaranteeGuarantee}>{guarantee.guarantee}</span></div>
            </div>
            <div style={styles.guaranteeInfo}>
              <div style={styles.keyContainer}><span style={styles.key}>{this.localization.get(`${this.props.translation}.startDate`)}</span></div>
              <div style={styles.valueContainer}>
                <span style={styles.value}>
                  {this.localization.getFormatedDate(guarantee.startDate, this.props.currentLanguage)}
                </span>
              </div>
            </div>
            {
              guarantee.endDate ?
                <div style={styles.guaranteeInfo}>
                  <div style={styles.keyContainer}><span style={styles.key}>{this.localization.get(`${this.props.translation}.endDate`)}</span></div>
                  <div style={styles.valueContainer}>
                    <span style={styles.value}>
                      {this.localization.getFormatedDate(guarantee.endDate, this.props.currentLanguage)}
                    </span>
                  </div>
                </div> : null
            }
            <div style={styles.guaranteeInfo}>
              <div style={styles.keyContainer}><span style={styles.key}>{this.localization.get(`${this.props.translation}.excessAmount`)}</span></div>
              <div style={styles.valueContainer}><span style={styles.value}>
                <BelfiusCurrencyText value={guarantee.excessAmount} prefix={'€'} />
              </span></div>
            </div>
            <div style={styles.guaranteeInfo}>
              <div style={styles.keyContainer}><span style={styles.key}>{this.localization.get(`${this.props.translation}.insuredAmount`)}</span></div>
              <div style={styles.valueContainer}><span style={styles.value}>
                <BelfiusCurrencyText value={guarantee.insuredAmount} prefix={'€'} />
              </span></div>
            </div>
            <div style={styles.guaranteeInfo}>
              <div style={styles.keyContainer}><span style={styles.key}>{this.localization.get(`${this.props.translation}.indirectLosses`)}</span></div>
              <div style={styles.valueContainer}><span style={styles.value}>{guarantee.indirectLosses ? this.localization.get('shared.yes') : this.localization.get('shared.no')}</span></div>
            </div>
          </div>
        );
      });
    return (
      <div>
        <div style={styles.informationContainer}>
          {info}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ shared }: ApplicationState): PropsFromState => ({
  currentLanguage: shared.currentLanguage
});

export default connect(mapStateToProps)(GuaranteeInformation);
